const PASSWORD_RULES = {
  minLength: 8,
  maxLength: 24,
};

export const PASSWORD_CRITERIA = [
  { key: 'length', test: (pw) => pw.length >= PASSWORD_RULES.minLength && pw.length <= PASSWORD_RULES.maxLength, label: `${PASSWORD_RULES.minLength}\u201324 characters total` },
  { key: 'uppercase', test: (pw) => /[A-Z]/.test(pw), label: 'At least one uppercase letter (A\u2013Z)' },
  { key: 'lowercase', test: (pw) => /[a-z]/.test(pw), label: 'At least one lowercase letter (a\u2013z)' },
  { key: 'number', test: (pw) => /[0-9]/.test(pw), label: 'At least one number (0\u20139)' },
  { key: 'specialChar', test: (pw) => /[!@#$%^&*]/.test(pw), label: 'At least one special character from: ! @ # $ % ^ & *' },
];

export const getPasswordErrors = (password) => {
  return PASSWORD_CRITERIA
    .filter((criteria) => !criteria.test(password))
    .map((criteria) => criteria.key);
};

export const validatePasswordStrength = (password) => {
  const failedCriteria = PASSWORD_CRITERIA.find((criteria) => !criteria.test(password));
  return failedCriteria ? failedCriteria.label : null;
};

export const isPasswordValid = (password) => {
  return PASSWORD_CRITERIA.every((criteria) => criteria.test(password));
};
